import { render, staticRenderFns } from "./StatsView.vue?vue&type=template&id=a9161740&scoped=true"
import script from "./StatsView.vue?vue&type=script&lang=js"
export * from "./StatsView.vue?vue&type=script&lang=js"
import style0 from "./StatsView.vue?vue&type=style&index=0&id=a9161740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9161740",
  null
  
)

export default component.exports